module.exports = __webpack_public_path__ + "static/img/CheryMotorH.e894cd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/CheryMotorH.png
// module id = T/Xg
// module chunks = 83